import api from "@/core/services/api.service";

const PublicService = {
   

    getEvents() {
        api.notHeader()
        return api.get("public", "fdptkd/events")
    },

    getMultimedia(params) {
        api.notHeader()
        return api.post("pbc/multimedia/list", params)
        
    },

    getClubsParticipantes(params) {
        api.notHeader()
        return api.post("pbc/events/clubs", params)
    },

    getParticipantes (params) {
        api.notHeader()
        return api.post("pbc/events/participantes", params)
    }

}

export default PublicService